(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
  function initLoadMore(section) {
    const button = section.querySelector('.load-more-btn');
    if (!button || button.dataset.initialised === '1') return;
    button.dataset.initialised = '1';

    button.addEventListener('click', async function () {
      if (button.classList.contains('is-loading')) return;

      const handle = button.dataset.collectionHandle;
      const perPage = parseInt(button.dataset.perPage, 10) || 4;
      const currentPage = parseInt(button.dataset.page, 10) || 1;
      const total = parseInt(button.dataset.total, 10) || 0;
      const nextPage = currentPage + 1;
      const grid = section.querySelector('.product-grid');

      button.classList.add('is-loading');
      button.disabled = true;

      try {
        const url = '/collections/' + encodeURIComponent(handle) + '?view=product-cards&page=' + nextPage;
        const response = await fetch(url, { headers: { 'Accept': 'text/html' } });
        if (!response.ok) throw new Error('Network response was not OK (' + response.status + ')');
        const html = await response.text();

        const temp = document.createElement('div');
        temp.innerHTML = html.trim();
        const items = temp.querySelectorAll('.product-item');

        items.forEach(function (item) { grid.appendChild(item); });

        button.dataset.page = nextPage;

        const loadedSoFar = nextPage * perPage;
        if (items.length === 0 || items.length < perPage || loadedSoFar >= total) {
          button.style.display = 'none';
        }
      } catch (e) {
        console.error('[custom-collection-product-grid] Load more failed:', e);
      } finally {
        button.classList.remove('is-loading');
        button.disabled = false;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function(section){
      initLoadMore(section);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
